import * as React from "react";
import { forwardRef } from "react";
const SvgShortlist = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11.1792 18.6769L5.60959 22.2773V3.88104L18.4861 3.88104V22.2773L12.9165 18.6769C12.3878 18.3351 11.7079 18.3351 11.1792 18.6769Z", stroke: "currentColor", strokeWidth: 1.6 }));
const ForwardRef = forwardRef(SvgShortlist);
export { ForwardRef as ReactComponent };
